/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfTransaction } from '../models/data-page-of-transaction';
import { Transaction } from '../models/transaction';
import { transactionCreateTransaction } from '../fn/transaction/transaction-create-transaction';
import { TransactionCreateTransaction$Params } from '../fn/transaction/transaction-create-transaction';
import { transactionDelete } from '../fn/transaction/transaction-delete';
import { TransactionDelete$Params } from '../fn/transaction/transaction-delete';
import { transactionGetCarefinityTransaction } from '../fn/transaction/transaction-get-carefinity-transaction';
import { TransactionGetCarefinityTransaction$Params } from '../fn/transaction/transaction-get-carefinity-transaction';
import { transactionList } from '../fn/transaction/transaction-list';
import { TransactionList$Params } from '../fn/transaction/transaction-list';
import { transactionPut } from '../fn/transaction/transaction-put';
import { TransactionPut$Params } from '../fn/transaction/transaction-put';
import { transactionPut2 } from '../fn/transaction/transaction-put-2';
import { TransactionPut2$Params } from '../fn/transaction/transaction-put-2';

@Injectable({ providedIn: 'root' })
export class TransactionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `transactionList()` */
  static readonly TransactionListPath = '/transaction/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionList$Response(params?: TransactionList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfTransaction>> {
    return transactionList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionList(params?: TransactionList$Params, context?: HttpContext): Observable<DataPageOfTransaction> {
    return this.transactionList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfTransaction>): DataPageOfTransaction => r.body)
    );
  }

  /** Path part for operation `transactionCreateTransaction()` */
  static readonly TransactionCreateTransactionPath = '/transaction/createtransaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionCreateTransaction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionCreateTransaction$Response(params: TransactionCreateTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return transactionCreateTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionCreateTransaction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionCreateTransaction(params: TransactionCreateTransaction$Params, context?: HttpContext): Observable<Blob> {
    return this.transactionCreateTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `transactionPut()` */
  static readonly TransactionPutPath = '/transaction/updatetransaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionPut$Response(params: TransactionPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return transactionPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionPut(params: TransactionPut$Params, context?: HttpContext): Observable<Blob> {
    return this.transactionPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `transactionPut2()` */
  static readonly TransactionPut2Path = '/api/Transaction/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionPut2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionPut2$Response(params: TransactionPut2$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return transactionPut2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionPut2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  transactionPut2(params: TransactionPut2$Params, context?: HttpContext): Observable<Blob> {
    return this.transactionPut2$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `transactionDelete()` */
  static readonly TransactionDeletePath = '/api/Transaction/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionDelete$Response(params: TransactionDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return transactionDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionDelete(params: TransactionDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.transactionDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `transactionGetCarefinityTransaction()` */
  static readonly TransactionGetCarefinityTransactionPath = '/transaction/getCarefinitytransaction';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `transactionGetCarefinityTransaction()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionGetCarefinityTransaction$Response(params?: TransactionGetCarefinityTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<Transaction>> {
    return transactionGetCarefinityTransaction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `transactionGetCarefinityTransaction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  transactionGetCarefinityTransaction(params?: TransactionGetCarefinityTransaction$Params, context?: HttpContext): Observable<Transaction> {
    return this.transactionGetCarefinityTransaction$Response(params, context).pipe(
      map((r: StrictHttpResponse<Transaction>): Transaction => r.body)
    );
  }

}
